import React from 'react'

import { useRouter } from 'next/router'

import * as S from './styles'
import { Image } from '../image'
import { Text } from '../text'
import { BrIcon, EnIcon } from '@/assets/icons'

export type LanguageSwitchProps = {
  /**
   * isBiggerMobile is used as reference for lower resolutions
   *
   * @default false
   *
   * @example
   * ```tsx
   * <LanguageSwitch isBiggerMobile=true />
   * ```
   *
   */
  isBiggerMobile?: boolean

  /**
   * If the container is in darkMode
   * @default false
   * @example
   * ```tsx
   * <LanguageSwitch darkMode={true} />
   * ```
   * */
  darkMode?: boolean
}

export const LanguageSwitch: React.FC<LanguageSwitchProps> = ({
  isBiggerMobile,
  darkMode = false,
}) => {
  const router = useRouter()
  const nextLocale =
    router.locale === 'pt-BR'
      ? { text: 'English', code: 'en' }
      : { text: 'Português', code: 'pt-BR' }

  const switchLocale = () => {
    const path = router.asPath

    return router.push(path, path, { locale: nextLocale.code })
  }

  return (
    <S.LanguageSwitchContainer onClick={switchLocale}>
      <Image
        src={router.locale !== 'en' ? EnIcon : BrIcon}
        alt={router.locale !== 'en' ? 'EN-icon' : 'BR-icon'}
        defaultSize={{
          height: 20,
          width: 28,
        }}
      />
      <Text
        size={isBiggerMobile ? 'b4' : 'b3'}
        color={darkMode ? 'white' : 'black'}
        className="language-text"
      >
        {nextLocale.text}
      </Text>
    </S.LanguageSwitchContainer>
  )
}
